export default function ComoFuncionaSection() {
  const steps = [
    {
      number: '01',
      title: 'Diagnóstico',
      description: 'Analisamos suas necessidades de data center, backup corporativo e hospedagem de servidores em Manaus. Nossa equipe técnica realiza um levantamento completo da sua infraestrutura atual e identifica oportunidades de melhoria.',
      icon: 'ri-search-line'
    },
    {
      number: '02',
      title: 'Proposta',
      description: 'Elaboramos uma proposta personalizada com preço fixo em reais, detalhando todos os serviços, recursos e benefícios. Apresentamos as melhores soluções de data center e backup para seu negócio em Manaus.',
      icon: 'ri-file-text-line'
    },
    {
      number: '03',
      title: 'Implantação',
      description: 'Executamos a migração e configuração dos serviços com mínimo impacto nas suas operações. Nossa equipe especializada garante uma transição suave para o data center em Manaus com todo suporte necessário.',
      icon: 'ri-settings-3-line'
    },
    {
      number: '04',
      title: 'Suporte Contínuo',
      description: 'Oferecemos suporte técnico 24/7 via WhatsApp e telefone com atendimento humano. Monitoramento constante, backup automático e manutenção preventiva para garantir a continuidade do seu negócio.',
      icon: 'ri-customer-service-line'
    }
  ];

  return (
    <section id="como-funciona" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#0B3A6E] mb-4">
            Como Funciona
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Processo simples e transparente para implementar soluções de data center, backup corporativo e hospedagem de servidores em Manaus.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="bg-gradient-to-br from-gray-50 to-white rounded-xl p-8 shadow-lg border border-gray-100 h-full hover:shadow-xl transition-all duration-300">
                <div className="flex items-center justify-between mb-6">
                  <span className="text-5xl font-bold text-[#F5A623]/20">
                    {step.number}
                  </span>
                  <div className="w-12 h-12 bg-[#0B3A6E] rounded-lg flex items-center justify-center">
                    <i className={`${step.icon} text-xl text-white`}></i>
                  </div>
                </div>
                
                <h3 className="text-xl font-bold text-[#0B3A6E] mb-4">
                  {step.title}
                </h3>
                
                <p className="text-gray-600 leading-relaxed text-sm">
                  {step.description}
                </p>
              </div>
              
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                  <i className="ri-arrow-right-line text-3xl text-[#F5A623]"></i>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}